const lang = {
    'headline': 'Gogoro® 網站使用條款',
    'summary': [
        '最後更新日： 2022 年 1 月 1 日',
        '謝謝您造訪！請您在開始使用本網站 (定義如下) 及網頁內容前先充分、仔細閱讀以下使用條款與條件（下稱「本條款」）。本條款為您使用 Gogoro Inc. 及其關係企業與／或子公司（以下統稱為「Gogoro」）所提供的網站及網頁內容時，所需遵守的規定。您須瞭解，當您開始使用本網站的同時，即表示您已同意本條款的內容。如您不同意本條款，請勿使用本網站。',
    ],
    'sections': [{
        'title': '瞭解及接受本條款',
        'description': [
            '本條款適用您於任何作業系統連結至的 Gogoro 網站，包括但不限於 www.gogoro.com、network.gogoro.com、www.ridegoshare.com 及其所提供的服務（以下統稱“本網站”）。',
            'Gogoro 保留權利，但無義務，得隨時不經通知自行決定增加、變更、編輯、修正、修訂、修改或刪除本條款。除於條款中另有規定者外，本條款的更新版本將於公告日生效。您應定期檢閱本條款，以確認其有無變更。此外，您在更新版本公告日後對於本網站的持續使用，將視為您已瞭解並同意該變更內容。',
        ],
    }, {
        'title': '使用資格',
        'description': [
            '您必須年滿 13 歲以上，才能申請簽署 Gogoro Network® 智慧電池服務合約或使用本網站，但 Gogoro 保留最終核准與否的權利。若您年滿 13 歲但未滿 20 歲，您應在父母或法定監護人之陪同下一起審閱本條款，於確定您與父母或法定監護人均充分瞭解並同意本條款後，再行在父母或法定監護人之陪同下簽署 Gogoro Network 智慧電池服務合約。',
            '若您代表公司、機構或其他團體使用本網站，則您確認並擔保您具有代表該團體接受本條款、申請 Gogoro Network 智慧電池服務及使用本網站的完整權限，且您透過本網站所為的一切行為皆直接對該團體發生效力。本網站及網頁內容（定義如下）不得提供予任何第三人作為營利使用。',
        ],
    }, {
        'title': '網頁內容',
        'description': [
            '本條款所稱「網頁內容」包括但不限本網站上，或透過本網站所呈現的文字、使用者介面、資訊、數據、相片、影片、音訊片段、軟體、腳本、圖形、互動功能、視覺介面、商標、標誌、聲音、音樂、美編、編碼、設計、架構、表達、「界面外觀」，及前述事項的組合。Gogoro 擁有、持有、控制、或被授權使用網頁內容，網頁內容皆受到商品包裝、著作權、專利、商標、公開權、其他財產權、智慧財產權及不公平競爭等相關法令規定的保護。',
            '您瞭解您須自行承擔存取本網站及網頁內容的所有風險，且您對自己或他人因您存取本網站及網頁內容所造成的任何損害或損失，應自行單獨負責。Gogoro 不保證您所接觸的本網站或網頁內容的任何部分為正確、完整或可使用，或未來將持續維持正確、完整或可使用的狀態。Gogoro 有權利但無義務，得隨時以任何理由或毋須理由，自行決定增加、變更、編輯、修正、修訂、修改、刪除、限制或阻擋存取本網站或網頁內容的全部或一部分。',
            '當您使用網頁內容時，除有 Gogoro 事前書面同意外，您須遵守下列事項：(1) 不得刪除任何網頁內容複本中的專屬權聲明；(2) 僅得將該網頁內容作為您個人非營利的參考，且不得將該網頁內容重製或張貼至已連結的電腦，或透過任何媒體播送該網頁內容；(3) 不得對該網頁內容進行任何修改；且 (4) 不得對於該網頁內容為任何額外的聲明或保證。',
        ],
    }, {
        'title': '帳號及密碼',
        'description': [
            '為使用本網站或網頁內容，您可能被要求於 Gogoro 所提供之平台（下稱「該平台」）上，建立1個帳戶，包括但不限於創設使用者名稱與密碼。您保證在該平台申請設立帳戶時，提供真實、完整、正確且最新之資訊，倘該等資訊有任何變更或過期，您應立即更新該等必要資訊，俾使 Gogoro 得與您聯絡並提供相關服務。您瞭解並同意，若因您所提供之資訊不真實、不正確、不完整或已過期，導致您未能收受任何與 Gogoro 服務相關之資訊（包括但不限於本條款之修訂）或您因此無法使用 Gogoro 服務，應由您自行承擔或負責賠（補）償因此所生或相關的一切損害（失）。',
            'Gogoro 允許年滿13歲以上的個人建立個人帳戶。若您年滿 13 歲但未滿 20 歲，您應在父母或法定監護人之陪同下一同審閱本條款及該平台之使用條款及隱私權政策，於確定您與父母或法定監護人均充分瞭解並同意本條款及該平台之使用條款及隱私權政策後，再行在父母或法定監護人之陪同下建立個人帳戶。',
            '您應遵守 Gogoro 就建立使用者帳號及密碼所訂定之規則及程序，且您瞭解並同意密碼具有機密性，您對您的密碼負有保密義務，應妥善保管您的帳號密碼，不得提供或洩露予任何第三人。',
            '任何依照 Gogoro 所定程序輸入使用者帳號及密碼者，而與您所留存之登入資料相符時，無論是否係由您親自輸入，均將推定為您本人使用。您同意對使用該帳號所為之行為自負全責，故切勿任意向第三人揭露您帳戶之資訊。',
            '若您發現或懷疑您的帳號或密碼被盜用，或被任何第三人以未經授權之方式使用時，請立即透過 support.tw@ridegoshare.com 聯絡我們。若 Gogoro 知悉您的帳號或密碼被冒用時，將立即以任何合法方式傳送通知予您，並暫停提供服務予該帳號，若該帳號被盜用或冒用係因下列原因所致，因該帳號所生或與之相關的一切損害（失），應由您自行承擔或負責賠（補）償：',
            [
                '您未妥善保管帳號密碼；',
                '您自行將帳號密碼提供予任何第三人；',
                '您未使用 Gogoro 所提供的帳號安全機制；或',
                '其他任何可歸責於您的事由。',
            ],
            '如果 Gogoro 判斷認為您可能透過本網站從事侵權或犯罪行為，或您違反本條款之規定時，Gogoro 除得行使法律所賦予的其他權利外，亦有權得拒絕提供您服務、關閉或暫停您個人帳戶或為其他行為，包括但不限於取消所有 Gogoro 賦予您的權利、利益或活動資格等或終止所有 Gogoro 與您之間的契約關係。'
        ],
    }, {
        'title': '發票',
        'description': [
            'Gogoro 將依法就您所支付的費用開立電子發票，並將電子發票儲存於會員載具中，系統亦會即時以電子郵件寄送發票開立通知予您，Gogoro 收到中獎清冊後將於開獎翌日起10日內通知中獎。如欲索取電子發票證明聯，請您透過 support.tw@ridegoshare.com 聯絡我們，我們會將紙本發票郵寄至您所指定的地址，請於收到電子發票證明聯後自行妥善保管，若有遺失或毀損等，恕不補發。您亦得使用本網站自行下載及列印電子發票證明聯。',
        ],
    }, {
        'title': '隱私',
        'description': [
            'Gogoro 已制定本網站之隱私權政策（「Gogoro 隱私權政策」），且 Gogoro 隱私權政策為本條款的一部分。您必須充分、仔細閱讀 Gogoro 隱私權政策。當您使用本網站的同時，即視為您瞭解並同意接受 Gogoro 隱私權政策，且您亦瞭解，您所提供予本網站的任何訊息或資訊皆有遭他人讀取或攔截的風險。',
        ],
    }, {
        'title': '更新',
        'description': [
            'Gogoro 可能不定時進行更新或升級本網站，以新增功能、解決技術問題與提升您的使用者體驗。本網站可能提供自動更新功能，讓 Gogoro 可以自動更新本網站。您可以透過本網站，更改自動更新選項設定。但在某些特定少數情況下，本網站仍可能自動進行更新，無論您就本網站之自動更新設定為何。例如，我們可能會提供自動更新以修補您網路中的安全性漏洞或弱點。',
        ],
    }, {
        'title': '第三方連結',
        'description': [
            '若本網站包含連接至其他網站或第三方所提供之服務或網路資源的連結（下稱「第三方連結」），該等連結僅供您方便所設，不得解釋為 Gogoro 與該等網站、服務或網路資源之所有者或經營者間存有任何關聯，該等網站、服務或網路資源之內容亦非 Gogoro 所得控制，Gogoro 不為第三方連結或其內容之功能性、正確性、合法性或合適性等背書，若您連接至該等網站、服務或網路資源，應自行承擔一切風險，Gogoro 就您因使用該等網站、服務或網路資源所生或與之相關的一切損害（失）皆不負任何賠（補）償責任。',
        ],
    }, {
        'title': '免責聲明',
        'description': [
            '本網站及網頁內容係基於「現有狀態」及「現可使用狀態」進行傳輸，Gogoro 不提供任何保證，無論明示或默示，包含但不限於保證其不具權利瑕疵、正確、不侵權、具可銷售性，或符合特定目的。Gogoro 於任何情況下，均未保證本網站及網頁內容係安全、無誤，或得在任何特定時間、地點進行存取，或將更正缺陷或錯誤，或您得透過存取或使用本網站及網頁內容，達到符合您要求的特定結果，亦不保證您會被通知或您將取得本網站及網頁內容之最新版本。',
            'Gogoro 得不經通知變更本網站及網頁內容的所有資訊。Gogoro 與其董事、員工、代理人、供應商、商業夥伴及網站／網頁內容的提供者皆不保證且無法確保您自本網站所接收或下載的任何內容皆未含有電腦病毒，或其他有害或具破壞性的成分。',
            'Gogoro 茲聲明不為您因使用或存取本網站、其內容或第三方連結有關的任何行為、債務不履行、錯誤、中斷、瑕疵、運作或傳輸的遲延、惡意軟體、第三方未經授權的存取，所導致的任何及所有損害、責任或傷害負責。',
        ],
    }, {
        'title': '責任範圍',
        'description': [
            '於法律許可的最大範圍內，Gogoro 對於您任何間接性、附隨性、偶發性或懲罰性損害（失）皆不負賠（補）償責任，無論該等損害（失）係基於契約、違反擔保、侵權（含過失）或其他法律依據，即便 Gogoro 曾被告知該等損害（失）存在或發生之可能性時亦同。',
            '於法律許可的最大範圍內，就因您使用本網站所生或與之相關的一切損害（失），Gogoro 對您所負的責任僅以 Gogoro 所收取之費用為限，無論該等損害（失）係基於契約、違反擔保、侵權（含過失）或其他法律依據。即便存在數個因您使用本網站所生或與之相關的爭訟時，亦不會因此增加或擴張前述賠償金額上限。',
        ],
    }, {
        'title': '損害填補',
        'description': [
            '就因您違反本條款而使用、不當使用或存取本網站、網頁內容及第三方連結而造成的第三人請求、主張及損害（失），您同意賠（補）償並使 Gogoro 及其董事、員工、代理人、承包商、供應商、商業夥伴免於任何因此所生或與之相關的請求、損害（失）、罰款、成本及費用（包括但不限於合理之律師費用）。您同意在合理要求的情況下，協助 Gogoro 及其董事、員工、代理人、承包商、供應商、商業夥伴就任何因您違反本條款或不當使用本網站而招致之爭訟進行答辯，且未經 Gogoro 事前書面同意，您不得擅自拋棄對任何第三人求償權利，亦不得就任何事項與任何第三人試行和解。本損害填補規定在您停止使用本網站或 Gogoro 終止您的帳號後仍持續有效。',
        ],
    }, {
        'title': '準據法與管轄',
        'description': [
            '您同意因本條款或因您使用本網站所生或與之相關的一切爭議或糾紛，皆以中華民國（台灣）法律為準據法。就您與 Gogoro 間因本條款或因您使用本網站所生或與之相關的一切爭議或糾紛，您同意先與 Gogoro 依友好協商方式解決該爭議或糾紛；若雙方未能於 60 日內依友好協商方式解決時，您或 Gogoro 任一方皆可就該爭議或糾紛向臺灣臺北地方法院聲請調解；若調解未能成立，雙方同意以臺灣臺北地方法院為第一審專屬管轄法院。雙方同意，在該等爭議或糾紛未能依照本條所定程序予以解決時，不得採取任何其他紛爭解決方式。',
        ],
    }, {
        'title': '一般條款',
        'description': [
            '您不應寄發任何未經徵求的構想給 Gogoro 或任何 Gogoro 人員。Gogoro 或任何 Gogoro 人員均不會接受或考慮任何未經徵求的構想，包含但不限於新的產品設計、技術、程序、材料或行銷活動等構想。儘管 Gogoro 要求您不得寄發任何未經徵求的構想給 Gogoro 或任何 Gogoro 人員，但為避免 Gogoro 的商品或行銷計畫恰巧與任何您所提供給 Gogoro 或任何 Gogoro 人員的未經徵求的構想相似，而產生任何可能或潛在的爭議或誤會，您特此同意在沒有任何補償的情況下，將您寄發給 Gogoro 或任何Gogoro 人員的未經徵求的構想讓與給 Gogoro。Gogoro 不會將您寄發給 Gogoro 或任何Gogoro 人員的未經徵求的構想，視為機密或專有財產，且 Gogoro 得基於任何目的、以任何方式，利用或散布您所提交的未經徵求的構想。',
            '本條款構成您與 Gogoro 間，就您存取或使用本網站或網頁內容有關事項的完整合意，並取代所有您之前或同時期與 Gogoro 間就您存取或使用本網站或網頁內容往來的任何意思表示(無論是口頭、書面或電子)。若本條款之任一規定被法院或其他有管轄權之機關認定為無法執行、不生效力或無效時，該規定應在必要的最小範圍內被限制或刪除，並為另一最符合本條款意旨的有效規定所取代。此外，本條款的其他規定仍應具完整效力且繼續有效。',
            '您不得在違反任何應適用的法令(包含但不限於臺灣出口法令)的情況下，使用或出口任何從本網站或網頁內容所得資料，或前述網頁內容的複本或改寫本。',
            '除本條款另有規定者外，Gogoro 得依任何合法方式傳送通知予您，包含但不限於在本網站上公告、或寄至任何您提供給 Gogoro 的電子郵件地址或郵寄地址。您瞭解您有更新您電子郵件地址及郵寄地址的義務，並應定期查閱本網站公告。您同意以寄發電子郵件至 support.tw@ridegoshare.com 的方式通知 Gogoro。',
            'Gogoro 未堅持嚴格履行或執行本條款的任何規定的行為，不應被理解或構成 Gogoro 放棄將來嚴格履行或執行該規定，或放棄嚴格履行或執行本條款的其他規定的權利。Gogoro 與您或任何第三人間的行為，亦不應被認定係變更或取代本條款的任何規定。Gogoro 在任何特定情況下，任何放棄遵循本條款的權利的行為，不應被視為 Gogoro 放棄將來遵循本條款的權利。除有經 Gogoro 合法授權的代表所簽署的書面文件外，任何 Gogoro 放棄遵循本條款的權利的意思表示均不具拘束力。本條款不應被解釋或理解為任何第三人主張任何權利或救濟的依據。',
            '本條款內之標題僅供方便之用，不影響本條款內容之解釋。',
        ],
    }, {
        'title': '意見回饋',
        'description': [
            '若您對本條款有任何建議或疑問，您可以透過 support.tw@ridegoshare.com 聯絡我們。惟請注意任何您所提供給 Gogoro 的意見回饋及資料皆不會被視為係機密資訊。',
        ],
    }],
    'copyright': [
        '© 2022 Gogoro 及/或其關係企業。版權所有。',
    ]
};

export default lang;
